import hydro from '../../content/places/arenal/geo/hydro.json'
import { latLonToWorld } from './geo'

interface Point {
  x: number
  z: number
}

interface PreparedRing {
  points: Point[]
  minX: number
  maxX: number
  minZ: number
  maxZ: number
}

type LonLat = [number, number]

function prepareRing(ring: LonLat[]): PreparedRing {
  // The source polygon remains full-fidelity for rendering. A decimated copy is
  // sufficient for fast terrain masking at the DEM's ~170 m sample spacing.
  const stride = Math.max(1, Math.floor(ring.length / 700))
  const points: Point[] = []
  for (let i = 0; i < ring.length; i += stride) {
    const [lon, lat] = ring[i]!
    points.push(latLonToWorld(lat, lon))
  }
  const [lastLon, lastLat] = ring[ring.length - 1]!
  const last = latLonToWorld(lastLat, lastLon)
  if (
    points.length === 0 ||
    points[points.length - 1]!.x !== last.x ||
    points[points.length - 1]!.z !== last.z
  ) {
    points.push(last)
  }
  return {
    points,
    minX: Math.min(...points.map((point) => point.x)),
    maxX: Math.max(...points.map((point) => point.x)),
    minZ: Math.min(...points.map((point) => point.z)),
    maxZ: Math.max(...points.map((point) => point.z)),
  }
}

const rings = (hydro.lake.rings as LonLat[][]).map(prepareRing)
const outer = rings[0]!
const holes = rings.slice(1)

function withinBounds(x: number, z: number, ring: PreparedRing): boolean {
  return x >= ring.minX && x <= ring.maxX && z >= ring.minZ && z <= ring.maxZ
}

function pointInRing(x: number, z: number, ring: PreparedRing): boolean {
  if (!withinBounds(x, z, ring)) return false
  let inside = false
  const points = ring.points
  for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
    const a = points[i]!
    const b = points[j]!
    const crosses =
      a.z > z !== b.z > z &&
      x < ((b.x - a.x) * (z - a.z)) / (b.z - a.z) + a.x
    if (crosses) inside = !inside
  }
  return inside
}

export function isInsideLake(x: number, z: number): boolean {
  if (!pointInRing(x, z, outer)) return false
  for (const hole of holes) {
    if (pointInRing(x, z, hole)) return false
  }
  return true
}

